import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  position: relative;
  height: 175px;
`;

export const Header = styled.header`
  border-bottom: 1px solid #ddd;
  color: #000;
  font-weight: 600;
  text-transform: capitalize;
  padding: 15px 10px 5px 10px;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .panel-title {
    font-size: 1em;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  ${mediaMaxWidth.tablet} {
    background: #fff !important;
    padding: 5px 0;

    .panel-title {
      padding: 20px 15px 5px 15px;
      color: #525252;
      background: #ffffff;
      text-align: left;
      border-top: 2px solid #fff;
      letter-spacing: 1px;
      width: calc(100vw - 40px) !important;
      margin-top: -10px;
      margin-left: -15px;
      font-size: 0.875em;
    }
  }
`;

export const Body = styled.div`
  padding: 5px 15px;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  margin: 15px 0;
`;

interface IColumnProps {
  flex: number;
}

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props: IColumnProps) => props.flex};
  align-items: center;
`;

interface INumberProps {
  fontSize: string;
}

export const Number = styled.div`
  display: flex;
  font-size: ${(props: INumberProps) => props.fontSize === "large" && "1.7em"};
  position: relative;
  left: -8px;

  ${mediaMaxWidth.phone} {
    font-size: ${(props: INumberProps) =>
      props.fontSize === "large" && "1.8em"};
  }
`;

export const InfoDot = styled.div`
  svg {
    font-size: 0.4em;
    position: absolute;
    top: 18px;
    right: -18px;
    color: #bbbbbb;
    transition: 0.1s ease-in-out;

    ${mediaMaxWidth.phone} {
      top: 15px;
      right: -17.5px;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  font-size: 0.9em;
  letter-spacing: 0.02em;
  margin: 10px 0;
  width: 100px;
  text-align: center;

  ${mediaMaxWidth.phone} {
    font-size: 0.8em;
    margin: 10px 0 0 0;
  }
`;
